module.exports=/[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/


//////////////////
// WEBPACK FOOTER
// ./node_modules/uc.micro/categories/Z/regex.js
// module id = 242
// module chunks = 0